import React, { useState, useEffect } from 'react'
import { geometry2feature } from '../utils/location'
import { MapContainer, TileLayer, LayersControl, GeoJSON } from 'react-leaflet'
import MarkerClusterGroup from 'react-leaflet-markercluster';
import * as L from "leaflet";
import "leaflet/dist/leaflet.css"
import { coloredMarker } from '../utils/marker'
import UserLocate from './UserLocate'

require('react-leaflet-markercluster/dist/styles.min.css')

const LocationMap = ({ onSelect, plots, position, zoom }) => {
    const [map, setMap] = useState(null)
    const myPlots = plots.filter(p => p.location && p.location.geometry).map(p => {
        const feature = geometry2feature(p.location.geometry)
        feature.properties = { ...p }
        return feature
    })

    useEffect(() => {
        if (map) {
            if (plots.length > 0) {
                const points= myPlots.map(p => {return p.geometry.coordinates.reverse()})
                const bounds= L.latLngBounds(points)
                //points.forEach(p => bounds.extend(p))
                map.fitBounds(bounds)
                //map.fitBounds(group.getBounds())
                //map.setView(position, zoom)
            }
            else {
                map.setView(position, zoom)
            }
        }

    }, [position, zoom, plots])

    const pointToLayer = (feature, latlng) => {
        const color = feature.properties.color || process.env.REACT_APP_PRIMARYCOLOR
        const marker = L.marker(latlng, {icon: coloredMarker({ L, color })})
        marker.on("click", (e) => {
            onSelect(feature.properties.id)
        })

        return marker
    }

    const onEachFeature = (feature, layer) => {
        layer.bindTooltip(feature.properties.description, { permanent: true })
    }

    return (
        <MapContainer center={position} zoom={zoom} scrollWheelZoom={true} style={{ height: '100%', zIndex: 0 }} whenCreated={setMap} >
            <LayersControl position="topright">
                <LayersControl.BaseLayer checked name="OpenStreetMap">
                    <TileLayer
                        attribution='&copy; <a href="https://www..org/copyright">OpenStreetMap</a> contributors'
                        url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
                    />
                </LayersControl.BaseLayer>
                <LayersControl.BaseLayer name="Luchtfoto">
                    <TileLayer
                        attribution='&copy; <a href="https://www.nationaalgeoregister.nl/">Nationaal Georegister</a>'
                        url="https://service.pdok.nl/hwh/luchtfotorgb/wmts/v1_0/Actueel_ortho25/EPSG:3857/{z}/{x}/{y}.jpeg"
                    />
                </LayersControl.BaseLayer>
            </LayersControl>
            <MarkerClusterGroup
                showCoverageOnHover={true}
                chunkedLoading={true}
                singleMarkerMode={false}
                zoomToBoundsOnClick={true}
                maxClusterRadius={80}
                spiderfyOnMaxZoom={true}
            >
                <GeoJSON key={new Date().getTime()} data={myPlots} pointToLayer={pointToLayer} onEachFeature={onEachFeature} />
            </MarkerClusterGroup>
            {window.location.protocol === 'https:' && <UserLocate />}
        </MapContainer>
    )
}

export default LocationMap
